export default __webpack_public_path__ + "static/media/rectangle3@3x.8dcd7fcb.png";